// this file will used for temporary until the end of transition period
// Then will start on Phase 2 for dynamic template value
let CompSS2 = {};

CompSS2['loadingTemplate'] = 'd_loading01';
CompSS2['m_footerTemplate'] = 'dynamicFooter';
CompSS2['footerTemplate'] = 'dynamicFooter';

CompSS2['pokerTemplete'] = 'd_redirectionHome';
CompSS2['m_pokerIndexTemplate'] = 'd_redirectionHome';
CompSS2['m_casinoIndexTemplate'] = 'd_redirectionHome';
CompSS2['casinoTemplate'] = 'd_redirectionHome';

CompSS2['downloadTemplate'] = 'd_redirectionHome';
CompSS2['m_downloadTemplate'] = 'd_mDownload_ss2';
CompSS2['downloadModalTemplate'] = 'd_downloadModal_ss2';

CompSS2['m_casinoTemplate'] = 'd_mCasino_landing';
CompSS2['homeTemplate'] = 'dynamicHome';
CompSS2['m_homeTemplate'] = 'dynamicHome';
CompSS2['affHomeTemplate'] = 'home_aff_ss2';
CompSS2['m_affHomeTemplate'] = 'home_aff_ss2';

CompSS2['scr918kissTemplate'] = 'd_Scr_ss2';
CompSS2['m_scr918kissTemplate'] = 'd_Scr_ss2';
CompSS2['cockfightIndexTemplate'] = 'd_cockfight_ss2';
CompSS2['cryptoWithdrawalTemplate'] = 'd_cryptoWithdrawal_ss2';
CompSS2['m_cryptoWithdrawalTemplate'] = 'd_cryptoWithdrawal_ss2';
CompSS2['affCryptoWithdrawalTemplate'] = 'd_cryptoWithdrawal_ss2';
CompSS2['m_affCryptoWithdrawalTemplate'] = 'd_mCryptoWithdrawal_ss2';
CompSS2['affWireTransferWithdrawalTemplate'] = 'd_wireTransferWithdrawal_ss2';
CompSS2['m_affWireTransferWithdrawalTemplate'] = 'd_mWireTransferWithdrawal_ss2';
CompSS2['affDepositLandingTemplate'] = 'd_depositLanding_ss2';
CompSS2['depositLandingTemplate'] = 'd_depositLanding_ss2';
CompSS2['m_depositLandingTemplate'] = 'd_depositLanding_ss2';
CompSS2['m_affDepositLandingTemplate'] = 'd_depositLanding_ss2';
CompSS2['affBankDetailsTemplate'] = 'd_bankDetails_ss2';
CompSS2['m_affBankDetailsTemplate'] = 'd_bankDetails_ss2';
CompSS2['phoneVerificationDialogTemplate'] = 'd_phoneVerification_ss2';
CompSS2['m_phoneVerificationDialogTemplate'] = 'd_phoneVerification_ss2';
CompSS2['affSettingsLandingTemplate'] = 'd_settingsLanding_ss2';
CompSS2['m_affSettingsLandingTemplate'] = 'd_settingsLanding_ss2';
CompSS2['m_hotgameTemplate'] = 'd_mobileHotgame_ss2';
CompSS2['transferTemplate'] = 'd_transfer_ss2';
CompSS2['affTransferTemplate'] = 'd_transfer_ss2';
CompSS2['m_transferTemplate'] = 'd_transfer_ss2';
CompSS2['m_affTransferTemplate'] = 'd_transfer_ss2';
CompSS2['affTransferReportTemplate'] = 'd_transfer_ss2';
CompSS2['m_affTransferReportTemplate'] = 'd_transfer_ss2';
CompSS2['historyAdjustmentTemplate'] = 'd_historyAdjustment_ss2';
CompSS2['m_historyAdjustmentTemplate'] = 'd_historyAdjustment_ss2';
CompSS2['affReportsTemplate'] = 'd_report_ss2';
CompSS2['m_affReportsTemplate'] = 'd_report_ss2';
CompSS2['m_qrcodePayTemplate'] = 'd_qrcodePay_ss2';
CompSS2['qrcodePayTemplate'] = 'd_qrcodePay_ss2';
CompSS2['resetPasswordTemplate'] = 'd_resetPassword_ss2';
CompSS2['p2pTransferTemplate'] = 'd_p2ptransfer_ss2';
CompSS2['m_p2pTransferTemplate'] = 'd_p2ptransfer_ss2';
CompSS2['bankDetailTemplate'] = 'd_bankDetail_ss2';
CompSS2['m_bankDetailTemplate'] = 'd_bankDetail_ss2';
CompSS2['m_myreferralTemplate'] = 'd_myReferral_ss2';
CompSS2['myreferralTemplate'] = 'd_myReferral_ss2';
CompSS2['m_bankTransferTemplate'] = 'd_bankTransfer_ss2';
CompSS2['m_affBankTransferTemplate'] = 'd_bankTransfer_ss2';
CompSS2['affBankTransferTemplate'] = 'd_bankTransfer_ss2';
CompSS2['affCryptoTemplate'] = 'd_crypto_ss2';
CompSS2['m_affCryptoTemplate'] = 'd_mCrypto_ss2';
CompSS2['bankTransferTemplate'] = 'd_bankTransfer_ss2';
CompSS2['changePasswordPopupTemplate'] = 'd_changePasswordPopup_ss2';
CompSS2['historyBettingSummaryTemplate'] = 'd_bettingSummary_ss2';
CompSS2['m_historyBettingSummaryTemplate'] = 'd_bettingSummary_ss2';
CompSS2['historyBettingHistoryTemplate'] = 'd_bettingHistory_ss2';
CompSS2['m_historyBettingHistoryTemplate'] = 'd_bettingHistory_ss2';
CompSS2['freeSpinHistoryTemplate'] = 'd_freeSpinHistory_ss2';
CompSS2['m_freeSpinHistoryTemplate'] = 'd_freeSpinHistory_ss2';
CompSS2['withdrawLandingTemplate'] = 'd_withdrawLanding_ss2';
CompSS2['m_withdrawLandingTemplate'] = 'd_withdrawLanding_ss2';
CompSS2['m_expressLandingTemplate'] = 'd_expressDeposit_ss2';
CompSS2['expressLandingTemplate'] = 'd_expressDeposit_ss2';
CompSS2['paginationTemplate'] = 'd_pagination_ss2';
CompSS2['m_affChangePasswordTemplate'] = 'd_changePassword_ss2';
CompSS2['affChangePasswordTemplate'] = 'd_changePassword_ss2';
CompSS2['changePasswordTemplate'] = 'd_changePassword_ss2';
CompSS2['m_changePasswordTemplate'] = 'd_changePassword_ss2';
CompSS2['withdrawPinTemplate'] = 'd_withdrawPin_ss2';
CompSS2['m_withdrawPinTemplate'] = 'd_withdrawPin_ss2';
CompSS2['affGalleryTemplate'] = 'd_gallery_ss2';
CompSS2['m_affGalleryTemplate'] = 'd_gallery_ss2';
CompSS2['m_historyControlPanelTemplate'] = 'd_historyControlPanel_ss2';
CompSS2['historyControlPanelTemplate'] = 'd_historyControlPanel_ss2';
CompSS2['affDepositReportTemplate'] = 'd_deposit_ss2';
CompSS2['m_affDepositReportTemplate'] = 'd_deposit_ss2';
CompSS2['mobileLoginJoinTabTemplate'] = 'd_mobileLoginJoinTab_ss2';
CompSS2['m_mobileLoginJoinTabTemplate'] = 'd_mobileLoginJoinTab_ss2';
CompSS2['m_mobileLoginJoinBtnTemplate'] = 'd_MobileLoginJoinBtn_ss2';
CompSS2['contactTemplate'] = 'd_contact_ss2';
CompSS2['m_contactTemplate'] = 'd_mContact_ss2';
CompSS2['affContactUsTemplate'] = 'd_contact_ss2';
CompSS2['m_affContactUsTemplate'] = 'd_contact_ss2';
CompSS2['selectBankDialogTemplate'] = 'd_selectBankDialog_ss2';
CompSS2['m_depositBankQrTemplate'] = 'd_bankqr_ss2';
CompSS2['depositBankQrTemplate'] = 'd_bankqr_ss2';
CompSS2['m_affWithdrawalTemplate'] = 'd_withdrawal_ss2';
CompSS2['withdrawalTemplate'] = 'd_withdrawal_ss2';
CompSS2['affWithdrawalReportTemplate'] = 'd_withdrawal_ss2';
CompSS2['affWithdrawalTemplate'] = 'd_withdrawal_ss2';
CompSS2['m_affWithdrawalReportTemplate'] = 'd_withdrawal_ss2';
CompSS2['m_withdrawalTemplate'] = 'd_withdrawal_ss2';
CompSS2['quickPayTemplate'] = 'd_quickpay_ss2';
CompSS2['m_quickPayTemplate'] = 'd_quickpay_ss2';
CompSS2['m_affMemberReportTemplate'] = 'd_member_ss2';
CompSS2['affMemberReportTemplate'] = 'd_member_ss2';
CompSS2['megaTemplate'] = 'd_mega_ss2';
CompSS2['m_megaTemplate'] = 'd_mMega_ss2';
CompSS2['psy8Template'] = 'd_Psy8_ss2';
CompSS2['m_psy8Template'] = 'd_mPsy8_ss2';
CompSS2['referralTemplate'] = 'd_referral_ss2';
CompSS2['m_referralTemplate'] = 'd_referral_ss2';
CompSS2['affCampaignTemplate'] = 'd_campaign_ss2';
CompSS2['m_affCampaignTemplate'] = 'd_campaign_ss2';
CompSS2['m_slotTemplate'] = 'd_mSlot_ss2';
CompSS2['m_fundsTemplate'] = 'd_funds_ss2';
CompSS2['m_changeProviderPasswordTemplate'] = 'd_changeProviderPassword_ss2';
CompSS2['changeProviderPasswordTemplate'] = 'd_changeProviderPassword_ss2';
CompSS2['m_pokerTemplate'] = 'd_poker_ss2';
CompSS2['promotionTemplate'] = 'd_promotion_ss2';
CompSS2['m_promotionTemplate'] = 'd_promotion_ss2';
CompSS2['m_subAffReportTemplate'] = 'd_subAffiliateReport_ss2';
CompSS2['subAffReportTemplate'] = 'd_subAffiliateReport_ss2';
CompSS2['affMemberSummaryTemplate'] = 'd_memberSummary_ss2';
CompSS2['m_affMemberSummaryTemplate'] = 'd_memberSummary_ss2';
CompSS2['depositTmQrTemplate'] = 'd_trueMoneyQR_ss2';
CompSS2['m_depositTmQrTemplate'] = 'd_trueMoneyQR_ss2';
CompSS2['myrefbonuscommTemplate'] = 'd_myrefbonuscomm_ss2';
CompSS2['m_myrefbonuscommTemplate'] = 'd_myrefbonuscomm_ss2';
CompSS2['m_cryptoDepositTemplate'] = 'd_crypto_ss2';
CompSS2['cryptoDepositTemplate'] = 'd_crypto_ss2';
CompSS2['eWalletAppsTemplate'] = 'd_eWalletApps_ss2';
CompSS2['m_eWalletAppsTemplate'] = 'eWalletApps_ss2';
CompSS2['m_lotteryTemplate'] = 'd_lottery_ss2';
CompSS2['lotteryTemplate'] = 'd_lottery_ss2';
CompSS2['lotteryIndexTemplate'] = 'd_lottery_ss2';
CompSS2['profileTemplate'] = 'd_profile_ss2';
CompSS2['m_profileTemplate'] = 'd_profile_ss2';
CompSS2['m_homeAppLandingTemplate'] = 'd_homeAppLanding_ss2';
CompSS2['homeAppLandingTemplate'] = 'd_homeAppLanding_ss2';
CompSS2['m_detailDialogTemplat'] = 'd_detailDialog_ss2';
CompSS2['historyDepositWithdrawTemplate'] = 'd_depositWithdraw_ss2';
CompSS2['m_historyDepositWithdrawTemplate'] = 'd_depositWithdraw_ss2';
CompSS2['m_fishingTemplate'] = 'd_fishing_ss2';
CompSS2['fishingTemplate'] = 'd_fishing_ss2';
CompSS2['fishingIndexTemplate'] = 'd_fishing_ss2';
CompSS2['loginAlertPopupTemplate'] = 'd_loginAlertPopup_ss2';
CompSS2['affMonthlyWinlossTemplate'] = 'd_monthlyWinLoss_ss2';
CompSS2['m_affMonthlyWinlossTemplate'] = 'd_monthlyWinLoss_ss2';
CompSS2['casinoIndexTemplate'] = 'd_casinoIndex_ss2';
CompSS2['liveTVTemplate'] = 'd_liveTv_ss2';
CompSS2['m_messageDetailTemplate'] = 'd_messageDetail_ss2';
CompSS2['affMonthlyCommTemplate'] = 'd_monthlyComm_ss2';
CompSS2['m_affMonthlyCommTemplate'] = 'd_monthlyComm_ss2';
CompSS2['settingsTemplate'] = 'd_settings_ss2';
CompSS2['m_settingsTemplate'] = 'd_settings_ss2';
CompSS2['m_accountTemplate'] = 'd_account_ss2';
CompSS2['memberInfoVerificationDialogTemplate'] = 'd_memberInfoVerification_ss2';
CompSS2['historyLandingTemplate'] = 'd_historylanding_ss2';
CompSS2['announcementBarTemplate'] = 'd_announcementBar_ss2';
CompSS2['m_announcementBarTemplate'] = 'd_announcementBar_ss2';
CompSS2['eSportIndexTemplate'] = 'd_eSportIndex_ss2';
CompSS2['lineDepositTemplate'] = 'd_lineDeposit_ss2';
CompSS2['m_lineDepositTemplate'] = 'lineDeposit_ss2';
CompSS2['depositProgressBarTemplate'] = 'd_depositProgressBar_ss2';
CompSS2['m_depositProgressBarTemplate'] = 'd_depositProgressBar_ss2';
CompSS2['reloadTemplate'] = 'd_reload_ss2';
CompSS2['m_reloadTemplate'] = 'd_reload_ss2';
CompSS2['mobileCardTemplate'] = 'd_mobileCard_ss2';
CompSS2['m_mobileCardTemplate'] = 'd_mobileCard_ss2';
CompSS2['pokerIndexTemplate'] = 'd_pokerIndex_ss2';
CompSS2['m_mobileLoginJoinBtnTemplate'] = 'd_MobileLoginJoinBtn_ss2';
CompSS2['m_mobileAnnouncementPageTemplate'] = 'd_announcement_ss2';
CompSS2['m_loginTemplate'] = 'd_mLogin_ss2';
CompSS2['sportIndexTemplate'] = 'd_sportIndex_ss2';
CompSS2['tvgamesIndexTemplate'] = 'd_tvgamesIndex_ss2';
CompSS2['languageModalTemplate'] = 'd_languageModal_ss2';
CompSS2['shareModalTemplate'] = 'd_shareModal_ss2';
CompSS2['m_shareModalTemplate'] = 'd_shareModal_ss2';
CompSS2['mobileWalletTemplate'] = 'd_mobileWallet_ss2';
CompSS2['bankAppsTemplate'] = 'd_bankApps_ss2';
CompSS2['m_bankAppsTemplate'] = 'd_bankApps_ss2';
CompSS2['afterloginbarTemplate'] = 'd_afterLoginBar_ss2';
CompSS2['homeLatestPromoTemplate'] = 'd_latestPromo_ss2';
CompSS2['m_homeLatestPromoTemplate'] = 'd_mobileLatestPromo_ss2';
CompSS2['m_historyPromotionTemplate'] = 'd_historyPromotion_ss2';
CompSS2['historyPromotionTemplate'] = 'd_historyPromotion_ss2';
CompSS2['sidebannerTemplate'] = 'd_sideBanner_ss2';
CompSS2['affDeleteBankDialogTemplate'] = 'd_deleteBankDialog_ss2';
CompSS2['m_affDeleteBankDialogTemplate'] = 'd_deleteBankDialog_ss2';
CompSS2['navbarTemplate'] = 'd_navbar_ss2';
CompSS2['m_navbarTemplate'] = 'd_navbar_ss2';
CompSS2['gamesTemplate'] = 'd_games_ss2';
CompSS2['gamesIndexTemplate'] = 'd_games_ss2';
CompSS2['m_gamesTemplate'] = 'd_games_ss2';
CompSS2['hotgameTemplate'] = 'd_hotgame_ss2';
CompSS2['messageTemplate'] = 'd_message_ss2';
CompSS2['m_messageTemplate'] = 'd_message_ss2';
CompSS2['myrefbonusTemplate'] = 'd_myrefbonus_ss2';
CompSS2['m_myrefbonusTemplate'] = 'd_myrefbonus_ss2';
CompSS2['m_affMyprofileTemplate'] = 'd_myProfile_ss2';
CompSS2['affMyprofileTemplate'] = 'd_myProfile_ss2';
CompSS2['affFundsLandingTemplate'] = 'd_fundsLanding_ss2';
CompSS2['latestPromoTemplate'] = 'homeLatestPromoTemplate';
CompSS2['m_cardPaymentTemplate'] = 'cardPayment_ss2';
CompSS2['slotTemplate'] = 'd_slot_ss2';
CompSS2['slotIndexTemplate'] = 'd_slot_ss2';
CompSS2['m_slotIndexTemplate'] = 'd_slot_ss2';
CompSS2['fastgamesTemplate'] = 'd_fastgames_ss2';
CompSS2['historyRewardsTemplate'] = 'd_historyRewards_ss2';
CompSS2['m_historyRewardsTemplate'] = 'd_historyRewards_ss2';
CompSS2['cardPaymentTemplate'] = 'd_cardPayment_ss2';
CompSS2['registerTemplate'] = 'd_register_ss2';
CompSS2['m_registerTemplate'] = 'd_m_register_ss2';
CompSS2['affRegisterTemplate'] = 'd_register_ss2';
CompSS2['m_affRegisterTemplate'] = 'd_register_ss2';
CompSS2['registerSuccessTemplate'] = 'd_registerSuccess_ss2';
CompSS2['transactionNoteTemplate'] = 'd_transactionnote_ss2';
CompSS2['m_transactionNoteTemplate'] = 'd_transactionnote_ss2';
CompSS2['redirectErrorTemplate'] = 'd_redirectError_ss2';
CompSS2['settingsSideNavbarTemplate'] = 'd_settingsSideNavbar_ss2';
CompSS2['m_bottomNavbarTemplate'] = 'd_bottomNav_ss2';
CompSS2['settingsTabHeaderTemplate'] = 'd_settingsTabHeader_ss2';
CompSS2['historyTransferTemplate'] = 'd_historyTransfer_ss2';
CompSS2['m_historyTransferTemplate'] = 'd_historyTransfer_ss2';
CompSS2['historyRebateTemplate'] = 'd_historyRebate_ss2';
CompSS2['m_historyRebateTemplate'] = 'd_historyRebate_ss2';
CompSS2['m_termsTemplate'] = 'd_terms_ss2';
CompSS2['m_homeBannerSliderTemplate'] = 'd_homeBannerSlider_ss2';
CompSS2['settingsMainWalletTemplate'] = 'd_settingsMainWallet_ss2';
CompSS2['desktopGameTabTemplate'] = 'd_desktopGameTab_ss2';
CompSS2['liveScoreTemplate'] = 'd_liveScore_ss2';
CompSS2['beforeloginbarTemplate'] = 'd_beforeLoginBar_ss2';
CompSS2['sidebarTemplate'] = 'd_sidebar_ss2';
CompSS2['m_sidebarTemplate'] = 'd_sidebar_ss2';
CompSS2['deleteDialogTemplate'] = 'd_deleteDialog_ss2';

CompSS2['affAddBankDialogTemplate'] = 'd_addBankDialog_ss2';
CompSS2['transactionButtonTemplate'] = 'd_transactionButton_ss2';

CompSS2['missionDiaryTemplate'] = 'd_missionDiary_ss2';
CompSS2['m_missionDiaryTemplate'] = 'd_missionDiary_ss2';

CompSS2['historyMissionRecordTemplate'] = 'd_historyMissionRecord_ss2';
CompSS2['m_historyMissionRecordTemplate'] = 'd_historyMissionRecord_ss2';
CompSS2['historySportOutstandingTemplate'] = 'd_sportOutstanding_ss2';
CompSS2['m_historySportOutstandingTemplate'] = 'd_sportOutstanding_ss2';
CompSS2['missionDiaryClaimDialogTemplate'] = 'd_missionDiaryClaimDialog_ss2';
CompSS2['m_missionDiaryClaimDialogTemplate'] = 'd_missionDiaryClaimDialog_ss2';
CompSS2['settingsUserVerificationTemplate'] = 'settings_user_verification_ss2';
CompSS2['emailVerificationDialogTemplate'] = 'd_emailVerification_ss2';
CompSS2['m_emailVerificationDialogTemplate'] = 'd_emailVerification_ss2';
CompSS2['m_settingsUserVerificationTemplate'] = 'settings_user_verification_ss2';
CompSS2['birthdateVerificationDialogTemplate'] = 'birthdateVerification_ss2';
CompSS2['emailVerificationLandingTemplate'] = 'd_emailVerificationLanding_ss2';
CompSS2['m_emailVerificationLandingTemplate'] = 'd_emailVerificationLanding_ss2';

// CompSS2['bankDetailLandingTemplate'] = 'bankDetailLanding_ss2';
// CompSS2['m_bankDetailLandingTemplate'] = 'bankDetailLanding_ss2';
// CompSS2['bankDetailCryptoTemplate'] = 'bankDetailCrypto_ss2';
// CompSS2['m_bankDetailCryptoTemplate'] = 'bankDetailCrypto_ss2';

CompSS2['bankDetailLandingTemplate'] = 'bankDetailLanding_ss2';
CompSS2['m_bankDetailLandingTemplate'] = 'bankDetailLanding_ss2';
CompSS2['affBankDetailLandingTemplate'] = 'bankDetailLanding_ss2';
CompSS2['m_affBankDetailLandingTemplate'] = 'bankDetailLanding_ss2';
CompSS2['bankDetailCryptoTemplate'] = 'bankDetailCrypto_ss2';
CompSS2['m_bankDetailCryptoTemplate'] = 'bankDetailCrypto_ss2';

CompSS2['instantRebateLandingTemplate'] = 'instantRebateLanding_ss2';
CompSS2['m_instantRebateLandingTemplate'] = 'instantRebateLanding_ss2';
CompSS2['instantRebateTemplate'] = 'instantRebate_ss2';
CompSS2['m_instantRebateTemplate'] = 'instantRebate_ss2';
CompSS2['instantRebateHistoryTemplate'] = 'instantRebateHistory_ss2';
CompSS2['m_instantRebateHistoryTemplate'] = 'instantRebateHistory_ss2';

CompSS2['sponsorsTemplate'] = 'sponsors_ss2';
CompSS2['m_sponsorsTemplate'] = 'sponsors_ss2';

CompSS2['ewalletWithdrawalTemplate'] = 'ewallet_ss2';
CompSS2['m_ewalletWithdrawalTemplate'] = 'ewallet_ss2';
CompSS2['affRewardsTemplate'] = 'rewards_beta';
CompSS2['bankDetailEWalletTemplate'] = 'bankDetail_EWallet_ss2';

CompSS2['webappDownloadGuideTemplate'] = 'd_webappDownloadGuide_ss2';

// leaderboard
CompSS2['leaderboardRankScoreTemplate'] = 'd_leaderboard_rank_score_01';
CompSS2['leardboardRewardPopupTemplate'] = 'd_leaderboard_reward_popup_01';
CompSS2['m_leardboardRewardPopupTemplate'] = 'd_leaderboard_reward_popup_01';
CompSS2['m_leardboardDateTimePopupTemplate'] = 'd_leaderboard_dateTime_popup_01';
CompSS2['m_dateTimeTemplate'] = 'd_dateTime_01';
CompSS2['leaderboardTemplate'] = 'd_leaderboard_01';
CompSS2['m_leaderboardTemplate'] = 'd_leaderboard_01';

// home component need to remove
CompSS2['homeBankStatusTemplate'] = 'd_homeBankStatus01_ss2';
CompSS2['m_mobileGameTabTemplate'] = 'd_mobileGameTab_ss2';
CompSS2['mobileReferralBannerTemplate'] = 'd_mobileReferralBanner_ss2';

CompSS2['myVipTemplate'] = 'd_myVIP_ss2';
CompSS2['m_myVipTemplate'] = 'd_myVIP_ss2';
CompSS2['myVipVipLevelTemplate'] = 'd_vipLevel_ss2';
CompSS2['m_myVipVipLevelTemplate'] = 'd_vipLevel_ss2';
CompSS2['myVipVipLevelUpDownTemplate'] = 'd_vipLevelUpDown_ss2';
CompSS2['m_myVipVipLevelUpDownTemplate'] = 'd_vipLevelUpDown_ss2';
CompSS2['myVipVipRedeemHistoryTemplate'] = 'd_vipRedeemHistory_ss2';
CompSS2['m_myVipVipRedeemHistoryTemplate'] = 'd_vipRedeemHistory_ss2';

CompSS2['promotionDialogTemplate'] = 'd_promotionDialog_ss2';
CompSS2['m_promotionDialogTemplate'] = 'm_promotionDialog_ss2';

CompSS2['sixDigitPinTemplate'] = 'sixDigitPin_ss2';

export default CompSS2;
